// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"a28c1c07","498":"6addbe94","703":"c0bc73db","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};